import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { colors } from '../../../../core/styles/theme/default';

const StyledError = styled.div`
  color: ${colors.error};
  font-size: ${rem(14)};
  margin-top: ${rem(6)};
`;

const FieldError = ({ text }: { text: string }) => {
  return <StyledError>{text}</StyledError>;
};

export default FieldError;
